export enum TimePeriod {
  today = "today",
  yesterday = "yesterday",
  thisWeek = "this_week",
  lastWeek = "last_week",
  thisMonth = "this_month",
  lastMonth = "last_month",
}

export const TimePeriods = [
  TimePeriod.today,
  TimePeriod.yesterday,
  TimePeriod.thisWeek,
  TimePeriod.lastWeek,
  TimePeriod.thisMonth,
  TimePeriod.lastMonth,
];
